module.exports = __webpack_public_path__ + "static/media/photo211.f05c518a.jpg";